import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AppLayout } from '../components/layout/AppLayout';
import { ProtectedRoute } from '../features/auth/ProtectedRoute';

const HomePage = lazy(() => import('../pages/HomePage'));
const ArchivePage = lazy(() => import('../pages/ArchivePage'));
const YunaPage = lazy(() => import('../pages/YunaPage'));
const BookPage = lazy(() => import('../pages/BookPage'));
const CampaignPage = lazy(() => import('../pages/CampaignPage'));
const PuzzlePage = lazy(() => import('../pages/PuzzlePage'));
const LoginPage = lazy(() => import('../pages/LoginPage'));
const RegisterPage = lazy(() => import('../pages/RegisterPage'));
const ProfilePage = lazy(() => import('../pages/ProfilePage'));
const AdminPage = lazy(() => import('../pages/AdminPage'));
const ChaptersPage = lazy(() => import('../pages/ChaptersPage'));
const CharactersPage = lazy(() =>
  import('../pages/StaticPages').then((module) => ({ default: module.CharactersPage })),
);
const WorldsPage = lazy(() =>
  import('../pages/StaticPages').then((module) => ({ default: module.WorldsPage })),
);
const PrivacyPage = lazy(() =>
  import('../pages/StaticPages').then((module) => ({ default: module.PrivacyPage })),
);
const TermsPage = lazy(() =>
  import('../pages/StaticPages').then((module) => ({ default: module.TermsPage })),
);
const NotFoundPage = lazy(() =>
  import('../pages/StaticPages').then((module) => ({ default: module.NotFoundPage })),
);
const RhaelysPage = lazy(() =>
  import('../pages/StaticPages').then((module) => ({
    default: () => <module.LockedSagaPage saga="Rhaelys" />,
  })),
);
const TerminusPage = lazy(() =>
  import('../pages/StaticPages').then((module) => ({
    default: () => <module.LockedSagaPage saga="Terminus" />,
  })),
);

function RouteFallback() {
  return <div className="route-loader" role="status"><span /> Recuperando registro…</div>;
}

export function App() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route element={<AppLayout />}>
          <Route index element={<HomePage />} />
          <Route path="archivo" element={<ArchivePage />} />
          <Route path="sagas/yuna" element={<YunaPage />} />
          <Route path="sagas/rhaelys" element={<RhaelysPage />} />
          <Route path="sagas/terminus" element={<TerminusPage />} />
          <Route path="libros/yuna-echoes-of-rhem" element={<BookPage />} />
          <Route path="personajes" element={<CharactersPage />} />
          <Route path="mundos" element={<WorldsPage />} />
          <Route path="campana" element={<CampaignPage />} />
          <Route path="campana/:campaignSlug" element={<PuzzlePage />} />
          <Route path="capitulos" element={<ChaptersPage />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="registro" element={<RegisterPage />} />
          <Route path="privacidad" element={<PrivacyPage />} />
          <Route path="terminos" element={<TermsPage />} />
          <Route element={<ProtectedRoute />}>
            <Route path="perfil" element={<ProfilePage />} />
          </Route>
          <Route element={<ProtectedRoute admin />}>
            <Route path="admin" element={<AdminPage />} />
          </Route>
          <Route path="404" element={<NotFoundPage />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
